module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0041_master_maker_detail")]) : _vm._e(), _vm._v(" "), _c('app-header', [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    attrs: {
      "title": "棚卸(棚卸報告)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n          更新日時：" + _vm._s(_vm.update_Date) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "180px",
      "float": "right",
      "font-size": "12px",
      "text-align": "right"
    }
  }, [_vm._v("\n\n          報告日：" + _vm._s(_vm.create_Date) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n      状態：\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "disabled": true
    },
    domProps: {
      "value": _vm.status_value
    }
  }), _vm._v("\n      提出:\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "60px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "5px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "readonly": true
    },
    domProps: {
      "value": _vm.new_or_resubmit_value
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n      報告者:\n      "), _c('input', {
    staticStyle: {
      "border": "solid #337ab7 1px",
      "width": "200px",
      "padding-left": "4px",
      "margin": "2px",
      "border-radius": "0px",
      "background-color": "#e2ecf5",
      "font-size": "12px"
    },
    attrs: {
      "readonly": true
    },
    domProps: {
      "value": _vm.created_by_value
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("棚卸報告年度区分")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['reporting_period'],
      "readonly": _vm.selectreadonly['reporting_period']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('reporting_period')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'reporting_period',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.reportingPeriodList), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("会社")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['company'],
      "readonly": _vm.selectreadonly['company']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('company')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'company',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.companylist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("部署")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['department'],
      "readonly": _vm.selectreadonly['department']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('department')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'department',
          value: $event.target.value
        })
      }
    }
  }, [(_vm.EditableUser == true) ? _c('option') : _vm._e(), _vm._v(" "), _vm._l((_vm.departmentlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("チーム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['team'] || _vm.teammode == false,
      "readonly": _vm.selectreadonly['team']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('team')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'team',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.teamlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("所管区分")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['jurisdiction_classification'],
      "readonly": _vm.selectreadonly['jurisdiction_classification']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('jurisdiction_classification')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'jurisdiction_classification',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.classificationlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('label', {
    staticClass: "col-xs-3 control-label esma_form_label"
  }, [_vm._v("システム")]), _vm._v(" "), _c('select', {
    staticClass: "select-box",
    attrs: {
      "disabled": _vm.selectdisable['system'],
      "readonly": _vm.selectreadonly['system']
    },
    domProps: {
      "value": _vm.selvalues[_vm.Searchmap('system')]
    },
    on: {
      "change": function($event) {
        _vm.SelectSearch({
          id: 'system',
          value: $event.target.value
        })
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.systemlist), function(r) {
    return _c('option', {
      key: r.val,
      domProps: {
        "value": r.val
      }
    }, [_vm._v(_vm._s(r.val))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [(_vm.alretteamreport && _vm.alretoutside == false) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※チーム単位報告\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretdepartmentreport && _vm.alretoutside == false) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※棚卸は部署単位で報告願います。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretoutside) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※報告がロックされています\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ViewMainInfomation == true),
      expression: "ViewMainInfomation == true"
    }]
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col0b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id] + '％'
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col0c), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ViewMainInfomation == true),
      expression: "ViewMainInfomation == true"
    }]
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.updatecertcheck
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || _vm.certeditable == false,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col1b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1c), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnlycol1c,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1d), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1e), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnlycol1e,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col1f), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), (_vm.alretunusedlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※未使用ライセンスが0でない場合、ライセンスの未使用理由の記載が必要です。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretexpiredlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※期限切れライセンスが0でない場合、期限切れライセンス対応の入力が必要です。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretremarkexpiredlicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※証書一覧備考の入力が必要です。\n            ")])], 1) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.updatedevicecheck
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || _vm.dev_editable == false,
        "val": _vm.values[f.id]
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col2b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "74%",
      "margin-bottom": "5px"
    }
  }, [_vm._v("\n            ① + ② + ③ + ④ = " + _vm._s(_vm.totallicense) + "\n          ")]), _vm._v(" "), _vm._l((_vm.formFields.col2c1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['lack_of_license'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['lost_license_certificate'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['no_evidence_of_license_receipt'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2c4), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 || (_vm.$store.state[_vm.stateCurrentRow]['number_of_unattached'] == 0 && _vm.$store.state[_vm.stateCurrentRow]['other'] == 0),
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), _vm._l((_vm.formFields.col2d), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      },
      on: {
        "on_update": _vm.numbersUpdated
      }
    })
  }), _vm._v(" "), (_vm.alrettotallicense == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※①～④の合計数が未紐付数と一致しません。\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.alretother == true) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n            ※④が0でない場合、[備考]欄での理由の記載が必要です。\n            ")])], 1) : _vm._e()], 2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col3b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2,
        "val": _vm.values[f.id]
      }
    })
  }))])]), _vm._v(" "), (_vm.adminview == true) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._l((_vm.formFields.col4), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly2 && _vm.readOnly3,
        "val": _vm.values[f.id]
      }
    })
  }), _vm._v(" "), (_vm.ViewEditbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.adminremarkeditbtn
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.ViewEadminremarkditSetbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.adminremarksetbtn
    }
  }, [_vm._v("入力完了")]) : _vm._e(), _vm._v(" "), (_vm.ViewEadminremarkditSetbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.adminremarkeditcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.ShowRejectBlock) ? _c('div', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "20px",
      "margin-right": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.ShowRejectPerson) ? _c('div', _vm._l((_vm.formFields.col4a), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": true,
        "val": _vm.values[f.id]
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(_vm.ShowRejectReason) ? _c('div', _vm._l((_vm.formFields.col4b), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly4,
        "val": _vm.values[f.id]
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.ViewRejectEditbtn) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "end",
      "margin-bottom": "10px"
    }
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                ※差戻理由を入力し、入力完了をクリックしてください。(任意)\n                ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.processApprovalCancel
    }
  }, [_vm._v("入力完了")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.rejectcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "30px",
      "margin-right": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "left",
      "margin-left": "-10px"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("＜　戻る")]), _vm._v(" "), (_vm.ViewEditbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.editbtn
    }
  }, [_vm._v("編集")]) : _vm._e(), _vm._v(" "), (_vm.ViewEditCancelbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#A6A6A6"
    },
    attrs: {
      "disabled": false
    },
    on: {
      "click": _vm.editcancelbtn
    }
  }, [_vm._v("ｷｬﾝｾﾙ")]) : _vm._e(), _vm._v(" "), (_vm.pageEditable == true) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("削除")]) : _vm._e(), _vm._v(" "), (_vm.ViewApproval) ? _c('button', {
    staticClass: "btn btn-primary process_approval_approve_btn",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": function($event) {
        _vm.ApprovalStage1()
      }
    }
  }, [_vm._v("承認")]) : _vm._e(), _vm._v(" "), (_vm.ViewApprovalHistory) ? _c('button', {
    staticClass: "btn btn-primary process_approval_approve_btn",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": function($event) {
        _vm.onConfirmInfomation()
      }
    }
  }, [_vm._v("申請ルート")]) : _vm._e(), _vm._v(" "), (_vm.ViewRejectbtn) ? _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.rejecteditbtn
    }
  }, [_vm._v(_vm._s(_vm.reject_label))]) : _vm._e(), _vm._v(" "), (_vm.ViewConfirmbtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#92D050",
      "border-color": "#92D050"
    },
    on: {
      "click": _vm.onConfirmExecuteProcessConfirmation
    }
  }, [_vm._v("申請")]) : _vm._e(), _vm._v(" "), (_vm.ViewSavebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.onLocalSaveInventory
    }
  }, [_vm._v(_vm._s(_vm.savewords))]) : _vm._e(), _vm._v(" "), (_vm.ViewModeChangebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "200px",
      "width": "7%",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#FF7C80",
      "border-color": "#FF7C80"
    },
    on: {
      "click": _vm.reportmodebtn
    }
  }, [_vm._v(_vm._s(_vm.reportmodewords))]) : _vm._e(), _vm._v(" "), (_vm.viewExportFilebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "float": "right",
      "margin-left": "5px",
      "margin-right": "5px",
      "background": "#337ab7"
    },
    on: {
      "click": _vm.initExportFile
    }
  }, [_vm._v("出力")]) : _vm._e()])])])], 1), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySave"
    },
    on: {
      "done": _vm.onInventorySaveCondirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySaveEnd"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventorySaveReject"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmInventoryExport"
    },
    on: {
      "done": _vm.onInventoryExportCondirmed
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteinventoryreportModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportModal"
    },
    on: {
      "done": _vm.onConfirmReportModeChange
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportModalReject"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "reportmodeinventoryreportEndModal"
    },
    on: {
      "done": _vm.onConfirmReportModeChangeEnd
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventoryonRejectEmbedded"
    },
    on: {
      "done": _vm.onReject
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirminventoryonRejectEmbeddednotification"
    },
    on: {
      "done": _vm.backToList
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "stage1ConfirmatioInventory"
    },
    on: {
      "done": _vm.ApprovalStage2
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "ConfirmatioInvventorybackToList"
    },
    on: {
      "done": _vm.backToList
    }
  }), _vm._v(" "), _c('application-confirmation-modal-inventory', {
    attrs: {
      "tag": "inventoryApplicationConfimationModal"
    },
    on: {
      "done": _vm.onCloseConfimation
    }
  }), _vm._v(" "), _c('file-download-modal', {
    attrs: {
      "tag": "runInventoryExportreportDownloadModal"
    },
    on: {
      "close": _vm.onCloseExportFile
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "10px",
      "text-align": "right",
      "color": "red"
    }
  }, [_vm._v("\n          ＊入力必須項目\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field col-xs-12"
  }, [_vm._v("\n            1.証書一覧\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　2．機器・ソフトウェア紐付明細\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　3．その他\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　4．管理者記載\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "report_field"
  }, [_vm._v("\n            　差戻\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b046a70","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0071_inventory_report.vue
// module id = 938
// module chunks = 0